import format from 'date-fns__legacy__/format'
import parse from 'date-fns__legacy__/parse'

/**
 * @param {QuoteRequestReviewAdd} model
 * @returns {ApiQuoteRequestReviewAdd}
 */
export const formatRequestReviewAdd = (model) => ({
  idCompanyQuotation: model.negotiationId,
  rating: model.rating,
  comment: model.comment,
})

/**
 * @param {QuoteRequestReviewUpdate} model
 * @returns {ApiQuoteRequestReviewUpdate}
 */
export const formatRequestReviewUpdate = (model) => ({
  idEvaluation: model.reviewId,
  rating: model.rating,
  comment: model.comment,
})


export const formatGenerateReadOnly = (item) => ({
  expireAt: format(parse(item.expireAt), 'DD/MM/YYYY HH:mm') ,
  link: item.link,
  accessCount: item.accessCount,
  isExpired: item.isExpired
})